export default "__VITE_ASSET__qr7yu36v__"